export default {
      id: "logo-usage",
      viewBox: "0 0 165 110",
      url: "../dist/images/" + "sprite.svg#logo-usage",
      toString: function () {
        return this.url;
      }
    }